angular.module('bmsApp.trugreen.job')
	.controller('AddVisitModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  $filter,
				  moment,
				  ConfigService,
				  EmployeeSvc,
					notify) {


			$scope.init = function () {
				$scope.config = ConfigService.config;
				$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
					options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
						parentEl: '.modal-content'
					})
				});

				$scope.dateChosen = moment();
			};

			$scope.cancel = function () {
				$modalInstance.dismiss('cancel');
			};

			$scope.confirm = function () {
				if(!$scope.assignedEmployeeId){
					notify({
						message: 'Please assign employee to this visit'
					});
					return;
				}

				$modalInstance.close({
					dateChosen: $scope.dateChosen,
					assignedEmployeeId: $scope.assignedEmployeeId
				});
			};

			$scope.assignEmployee = function (id) {
				$scope.assignedEmployeeId = id;
			};

			$scope.dateChange = function () {
				EmployeeSvc.getAvailable({date: $scope.dateChosen})
					.then(function (response) {
						$scope.availableEmployees = response.data.available_employees;
					});
			};

			$scope.assignedEmployeeId = null;
			$scope.availableEmployees = null;

		});
